//============================================================================
//======================= Language constants =================================
//============================================================================
export const ENGLISH_LANGUAGE_CODE_LK = 'EN';
export const BURMESE_LANGUAGE_CODE_LK = 'MM';
export const CHINESE_LANGUAGE_CODE_LK = 'CH';
//============================================================================
//======================= Popular Games Types ================================
//============================================================================
export const POPULAR_GAMES_LK = 'popular-gaming';
export const WINNER_GAMES_LK = 'winner-gaming';
//============================================================================
//======================= Trx Types Local ====================================
//============================================================================
export const TOPUP_LK = 'topup';
export const WITHDRAW_LK = 'withdraw';
//============================================================================
//======================= OTP types ==========================================
//============================================================================
export const REGISTER_MODE_SK = 'register';
export const LOGIN_MODE_SK = 'login';
export const RESET_MODE_SK = 'reset';
//============================================================================
//======================== Room Types ========================================
//============================================================================
export const CHANNEL_SK = 'channel';
export const CHAT_SK = 'chat';
//============================================================================
//======================== Trx Status ========================================
//============================================================================
export const REQUESTED_SK = 'requested';
export const ACCEPTED_SK = 'accepted';
export const REJECTED_SK = 'rejected';
//============================================================================
//======================== Trx Types =========================================
//============================================================================
export const TOPUP_SK = 'topup';
export const WITHDRAW_SK = 'withdraw';
export const BONUS_SK = 'bonus';
//============================================================================
//======================== Bonus Types =======================================
//============================================================================
export const REFERRAL_BONUS_SK = 'referral';
export const TOPUP_BONUS_SK = 'topup';
export const SPIN_BONUS_SK = 'spin';
export const POCKET_MONEY_BONUS_SK = 'pocket-money';
export const REGISTER_BONUS_SK = 'register';
//============================================================================
//======================== Payment Category Types ============================
//============================================================================
export const PAY_SK = 'pay';
export const BANK_SK = 'bank';
//============================================================================
//============================================================================
//============================================================================
export const CREATE_MODE_LK = 'create';
export const UPDATE_MODE_LK = 'update';
export const ADMIN_LK = 'admin';
export const USER_LK = 'user';
export const EMAIL_REQUIRED_SK = 'email_required';
export const SHARE_ID_LK = 'share_id';
